if (!customElements.get('product-swatches')) {
  class ProductSwatches extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelectorAll('.swatch');
      this.boundHandleSwatchClick = this.handleSwatchClick.bind(this);
      this.boundQuickshopSwatchClick = this.handleQuickshopSwatchClick.bind(this);
      this.boundBundleSwatchClick = this.handleBundleSwatchClick.bind(this);
      this.isQuickshop = this.closest('quickshop-drawer');
      this.customSwatchesTrigger = document.querySelector('.product-checkbox-bundle');
    }

    connectedCallback() {
      this.isBundle = this.dataset.isBundle === 'true';
      this.updateAvailabilityStyle();
      if (this.isQuickshop) {
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.boundQuickshopSwatchClick);
        });
      } else if (this.isBundle) {
        this.smpBundle = this.closest('smp-bundle');
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.boundBundleSwatchClick);
        });
      } else {
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.boundHandleSwatchClick);
        });
      }
    }

    disconnectedCallback() {
      if (this.isQuickshop) {
        this.swatches.forEach((swatch) => {
          swatch.removeEventListener('click', this.boundQuickshopSwatchClick);
        });
      } else if (this.isBundle) {
        this.swatches.forEach((swatch) => {
          swatch.removeEventListener('click', this.boundHandleSwatchClick);
        });
      } else {
        this.swatches.forEach((swatch) => {
          swatch.removeEventListener('click', this.boundHandleSwatchClick);
        });
      }
    }

    handleSwatchClick(event) {
      const swatch = event.target.closest('.swatch');
      const newUrl = swatch.dataset.url;

      // Deselect across swatch groups OF THE SAME EXPERIENCE only — one color may
      // be selected overall per experience. On A/B dual-arm pages the other arm's
      // pickers must keep their server-rendered state (combined pickers carry
      // data-combo-group; the legacy picker does not).
      const scope = this.closest('product-info') || document;
      const myExperience = Boolean(this.dataset.comboGroup);
      scope.querySelectorAll('product-swatches .swatch.selected').forEach((el) => {
        const host = el.closest('product-swatches');
        if (host && Boolean(host.dataset.comboGroup) === myExperience) el.classList.remove('selected');
      });
      scope.querySelectorAll('product-swatches').forEach((el) => {
        if (el === this) return;
        if (Boolean(el.dataset.comboGroup) !== myExperience) return;
        if (typeof el.clearGroupLabel === 'function') el.clearGroupLabel();
      });

      swatch.classList.add('selected');
      this.updateSwatchLabel(swatch);

      const variantId = document.querySelector('product-form input[type="hidden"][name="id"]');
      const productId = document.querySelector('product-form input[type="hidden"][name="product-id"]');

      variantId && (variantId.value = swatch.dataset.variantId);
      productId && (productId.value = swatch.dataset.productId);

      // if (window.fbq && swatch.dataset.variantId) {
      //   try {
      //     const productTitleElement = document.querySelector('.Product-title') || document.querySelector('h1');
      //     let productTitle = productTitleElement?.textContent || 'Product';

      //     productTitle = productTitle.replace(/\s+/g, ' ').trim();

      //     const colorLabel = swatch.dataset.colorLabel || '';
      //     const contentName = colorLabel ? `${productTitle} - ${colorLabel}` : productTitle;

      //     const priceInCents = parseFloat(swatch.dataset.price) || 0;
      //     const priceInDollars = priceInCents / 100;

      //     window.fbq('track', 'ViewContent', {
      //       content_ids: [swatch.dataset.variantId],
      //       content_name: contentName,
      //       content_type: 'product_group',
      //       currency: 'USD',
      //       value: priceInDollars,
      //     });
      //   } catch (error) {
      //     console.error('Error firing ViewContent event:', error);
      //   }
      // }

      if (newUrl) {
        // Keep the ?view= template param (e.g. ?view=combo) so refresh/back
        // stays on the same PDP experience after a cross-product swap
        let browserUrl = newUrl;
        const currentView = new URLSearchParams(window.location.search).get('view');
        if (currentView && !browserUrl.includes('view=')) {
          browserUrl += (browserUrl.includes('?') ? '&' : '?') + 'view=' + encodeURIComponent(currentView);
        }
        window.history.replaceState({ path: browserUrl }, '', browserUrl);
        this.updateSections(newUrl);
        this.closest('product-info').setAttribute('data-url', newUrl.split('?')[0]);

        // Keep product identity + analytics truthful after a client-side product swap.
        // igProductData is a map keyed by product id (see theme.liquid); combo PDPs
        // pre-render sibling entries server-side — this is only a sparse fallback.
        const newProductId = Number(swatch.dataset.productId) || null;
        if (newProductId) {
          window.__productIdFromTemplate = newProductId;
          if (window.igProductData && typeof window.igProductData === 'object' && !window.igProductData[String(newProductId)]) {
            window.igProductData[String(newProductId)] = {
              productId: newProductId,
              handle: swatch.dataset.handle || null,
              lowestVariantPrice: swatch.dataset.price ? Number(swatch.dataset.price) : null,
            };
          }
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'pdp_product_swap',
            product_id: newProductId,
            product_handle: swatch.dataset.handle || null,
            variant_id: Number(swatch.dataset.variantId) || null,
            price: swatch.dataset.price ? Number(swatch.dataset.price) / 100 : null,
            color: swatch.dataset.colorLabel || null,
            combo_group: this.dataset.comboGroup || null,
          });
        }
      }

      this.updateAvailabilityStyle();
    }

    async fetchSectionDoc(url, retries = 2) {
      for (let attempt = 0; attempt <= retries; attempt++) {
        try {
          const res = await fetch(url);
          if (res.ok) {
            return new DOMParser().parseFromString(await res.text(), 'text/html');
          }
        } catch (e) {
          // network error — fall through to retry
        }
        await new Promise((resolve) => setTimeout(resolve, 400 * (attempt + 1)));
      }
      console.error(`Section fetch failed after ${retries + 1} attempts:`, url);
      return null;
    }

    sectionUrl(url, sectionId) {
      // data-url may lack a query string (variant-mapping fallback) — pick the separator accordingly
      return `${url}${url.includes('?') ? '&' : '?'}section_id=${sectionId}`;
    }

    async updateSections(url) {
      const sectionId = this.dataset.sectionId;
      const doc = await this.fetchSectionDoc(this.sectionUrl(url, sectionId));
      if (!doc) {
        this.updateRebuySection(url);
        return;
      }
      this.doc = doc;

      const oldBulkAdd = document.querySelector('#bulk-add');
      const newBulkAdd = this.doc.querySelector('#bulk-add');

      const oldPresaleMessage = document.querySelector('#final-sale');
      const newPresaleMessage = this.doc.querySelector('#final-sale');

      const variantSelects = document.querySelector('variant-selects');

      // IMPORTANT: Replace button container FIRST, before custom-swatches initializes
      // This ensures custom-swatches.initialize() finds the correct button reference
      this.replaceHTML('.quantity-buy-btn-container');

      const oldBundleCheckbox = document.querySelector('.product-checkbox-bundle');
      const newBundleCheckbox = this.doc.querySelector('.product-checkbox-bundle');

      const oldCustomSwatches = document.querySelector('custom-swatches');
      const newCustomSwatches = this.doc.querySelector('custom-swatches');

      // Preserve the expanded state before replacements
      const wasExpanded = oldCustomSwatches && oldCustomSwatches.dataset.collapsed === 'false';

      if (oldBundleCheckbox && !newBundleCheckbox) {
        oldBundleCheckbox.remove();
      } else if (!oldBundleCheckbox && newBundleCheckbox) {
        document
          .querySelector('.quantity-buy-btn-container')
          .insertAdjacentHTML('beforebegin', newBundleCheckbox.outerHTML);
      } else if (oldBundleCheckbox && newBundleCheckbox) {
        if (wasExpanded) {
          newBundleCheckbox.classList.add('background');
          const input = newBundleCheckbox.querySelector('input');
          const checkbox = newBundleCheckbox.querySelector('.custom-purchase-option-checkbox');
          if (input) input.checked = true;
          if (checkbox) checkbox.classList.add('custom-checkbox-check');
        }
        oldBundleCheckbox.replaceWith(newBundleCheckbox);
      }

      if (oldCustomSwatches && !newCustomSwatches) {
        oldCustomSwatches.remove();
      } else if (!oldCustomSwatches && newCustomSwatches) {
        const clonedElement = newCustomSwatches.cloneNode(true);
        if (wasExpanded) {
          clonedElement.setAttribute('data-fetch-rendered', 'true');
        }
        document.querySelector('.product-checkbox-bundle').insertAdjacentElement('beforebegin', clonedElement);
      } else if (oldCustomSwatches && newCustomSwatches) {
        if (wasExpanded) {
          newCustomSwatches.setAttribute('data-fetch-rendered', 'true');
        }
        oldCustomSwatches.replaceWith(newCustomSwatches);
      }

      // document.querySelector('custom-swatches')?.clear();
      // document.querySelector('custom-swatches')?.initialize();

      const embroideryToggleContainer = document.querySelector('.embroidery-toggle-container');
      if (embroideryToggleContainer && !this.doc.querySelector('.embroidery-toggle-container')) {
        embroideryToggleContainer.remove();
      } else if (!embroideryToggleContainer && this.doc.querySelector('.embroidery-toggle-container')) {
        document
          .querySelector('.quantity-buy-btn-container')
          .insertAdjacentElement('beforebegin', this.doc.querySelector('.embroidery-toggle-container'));
      } else if (embroideryToggleContainer && this.doc.querySelector('.embroidery-toggle-container')) {
        embroideryToggleContainer.replaceWith(this.doc.querySelector('.embroidery-toggle-container'));
      }

      const embroideryPopup = document.querySelector('embroidery-popup');
      if (embroideryPopup && !this.doc.querySelector('embroidery-popup')) {
        embroideryPopup.remove();
      } else if (!embroideryPopup && this.doc.querySelector('embroidery-popup')) {
        document
          .querySelector('product-info')
          .insertAdjacentElement('beforebegin', this.doc.querySelector('embroidery-popup'));
      } else if (embroideryPopup && this.doc.querySelector('embroidery-popup')) {
        embroideryPopup.replaceWith(this.doc.querySelector('embroidery-popup'));
      }

      const finalSaleInput = document.querySelector('product-form input[name="properties[Heads Up]"]');
      if (finalSaleInput && newPresaleMessage) {
        finalSaleInput.value = 'Final sale. No returns or exchanges.';
      } else if (finalSaleInput && !newPresaleMessage) {
        finalSaleInput.value = null;
      }

      if (oldPresaleMessage && newPresaleMessage) {
        oldPresaleMessage.replaceWith(newPresaleMessage);
      } else if (!oldPresaleMessage && newPresaleMessage) {
        document.querySelector('variant-selects').insertAdjacentHTML('afterend', newPresaleMessage.outerHTML);
      } else if (oldPresaleMessage && !newPresaleMessage) {
        oldPresaleMessage.remove();
      }

      if (oldBulkAdd && !newBulkAdd) {
        oldBulkAdd.remove();
      } else if (!oldBulkAdd && newBulkAdd) {
        document.querySelector('.quantity-buy-btn-container').insertAdjacentHTML('afterend', newBulkAdd.outerHTML);
        document.querySelector('product-info').refreshBulkAdd();
      } else {
        console.log('no changes', oldBulkAdd, newBulkAdd);
      }

      this.replaceHTML('.product__media-wrapper');

      // Sync the lightbox modal with the new gallery; only the inner content is
      // swapped so the <product-modal> element keeps its listeners and closed state
      const oldModalContent = document.querySelector('product-modal .product-media-modal__content');
      const newModalContent = this.doc.querySelector('product-modal .product-media-modal__content');
      if (oldModalContent && newModalContent) oldModalContent.innerHTML = newModalContent.innerHTML;

      // Desktop hover-zoom binds onclick directly on the gallery images (magnify.js),
      // so it must be re-initialized after the gallery is replaced
      if (typeof enableZoomOnHover === 'function' && this.closest('product-info')?.hasAttribute('data-zoom-on-hover')) {
        enableZoomOnHover(2);
      }

      this.replaceHTML('.pdp-price-container');
      this.replaceHTML('.v2-flex-right');
      this.replaceHTML('product-tabs');

      // Combined PDP only: a swap can land on a different MODEL whose
      // description / fit / fabric accordion differs — refresh it from the
      // already-fetched section doc (no extra request). Gated to combo pickers
      // so legacy PDPs and the A/B normal arm keep production behavior
      // (same-model color swaps share the accordion content).
      if (this.dataset.comboGroup) {
        const oldDropdowns = (this.closest('product-info') || document).querySelector('.product-dropdowns');
        const newDropdowns = this.doc.querySelector('.product-dropdowns');
        if (oldDropdowns && newDropdowns) {
          oldDropdowns.replaceWith(newDropdowns);
        } else if (oldDropdowns && !newDropdowns) {
          oldDropdowns.remove();
        }

        // The size guide modal (#FittingModal) is server-rendered per product
        // (title + custom.product_size_chart_content metafield) and sits OUTSIDE
        // product-info, so no other replace refreshes it. Swap only its header and
        // inner content: the root node must survive (product-info caches
        // this.fittingModal and binds open/close on it), and so must the X close
        // span — a direct child of -content carrying its own click listener.
        const oldFittingModal = document.getElementById('FittingModal');
        const newFittingModal = this.doc.getElementById('FittingModal');
        if (oldFittingModal && newFittingModal) {
          ['.ProductTabs-fittingModal-content-header', '.ProductTabs-fittingModal-content-inner'].forEach((sel) => {
            const oldEl = oldFittingModal.querySelector(sel);
            const newEl = newFittingModal.querySelector(sel);
            if (oldEl && newEl) oldEl.replaceWith(newEl);
          });
        }
      }
      this.replaceHTML('script[data-selected-variant]');
      this.replaceHTML('variant-selects');
      // .quantity-buy-btn-container already replaced earlier (before custom-swatches init)
      this.replaceHTML('.klaviyo-bis-modal');
      this.replaceHTML('bis-trigger');
      this.replaceHTML('quantity-input');
      this.replaceHTML('quantity-select');

      // Replace every app block in this section pairwise by id;
      // a single '.shopify-app-block' replaceHTML only ever swapped the first one.
      // Rebuy blocks are skipped: swapping their DOM triggers Rebuy's async
      // remount with stale cached data — updateRebuySection refreshes them in place.
      document.querySelectorAll('.shopify-app-block[id]').forEach((oldBlock) => {
        if (oldBlock.querySelector('div[data-rebuy-id]')) return;
        const newBlock = this.doc.getElementById(oldBlock.id);
        if (newBlock) oldBlock.replaceWith(newBlock);
      });
      this.replaceHTML('.label-wrapper.desktop');
      this.replaceHTML('.label-wrapper.mobile');

      // Combo PDP: a swap can land on a different MODEL (Smooth <-> Lace), so the
      // product title must follow. Pairwise replace (mobile + desktop), scoped to
      // this section's product-info so unrelated sections are never touched.
      // div.product__title ONLY: each title block nests a hidden duplicate
      // <a class="product__title"> whose inclusion would break the pairing and
      // surface the unstyled link (it must travel inside its parent div instead).
      const infoScope = this.closest('product-info') || document;
      const newTitles = this.doc.querySelectorAll('div.product__title');
      infoScope.querySelectorAll('div.product__title').forEach((oldEl, i) => {
        if (newTitles[i]) oldEl.replaceWith(newTitles[i]);
      });
      if (this.doc.title) document.title = this.doc.title;

      // Judge.me preview badges (title stars) — replace pairwise (mobile + desktop),
      // scoped to product-info so drawer/reviews-section badges can't shift the pairing
      // The desktop badge lives INSIDE div.product__title, so the title
      // pairwise replace above already delivered it fresh (and consumed its
      // node from this.doc) — touching it again here would blank it. Only
      // badges OUTSIDE the title divs (the mobile one) need explicit
      // replacement; when the target product renders no badge (airf.pdp_rev),
      // blank the slot instead of keeping the previous product's count — the
      // wrapper itself stays for its reserved height.
      const newLooseBadges = [...this.doc.querySelectorAll('.judgeme-widget-preview-wrapper')].filter(
        (el) => !el.closest('div.product__title'),
      );
      infoScope.querySelectorAll('.judgeme-widget-preview-wrapper').forEach((oldEl) => {
        if (oldEl.closest('div.product__title')) return; // refreshed with the title
        const fresh = newLooseBadges.shift();
        if (fresh) oldEl.replaceWith(fresh);
        else oldEl.innerHTML = '';
      });
      // re-hydrate the freshly inserted badges even if the reviews-section fetch below fails
      window.jdgm?.init?.();

      // A/B dual-arm: refresh the OPPOSITE experience's pickers by identity so the
      // hidden arm tracks the swapped product (spec 2026-08-18 §4.1.2). The fetched
      // doc must itself be dual-arm — a swap can land on a sibling without the combo
      // metafield, whose section renders legacy-only; replacing from such a doc would
      // inject an unclassed (ungoverned, visible) picker into the combined cohort.
      const docHasCombined = !!this.doc.querySelector('product-swatches[data-combo-group]');
      const docHasNormal = !!this.doc.querySelector('product-swatches:not([data-combo-group])');
      if (docHasCombined && docHasNormal) {
        const myExperienceGroup = Boolean(this.dataset.comboGroup);
        infoScope.querySelectorAll('product-swatches').forEach((oldEl) => {
          if (Boolean(oldEl.dataset.comboGroup) === myExperienceGroup) return; // same arm: untouched
          const freshEl = oldEl.dataset.comboGroup
            ? this.doc.querySelector(`product-swatches[data-combo-group="${oldEl.dataset.comboGroup}"]`)
            : this.doc.querySelector('product-swatches:not([data-combo-group])');
          if (!freshEl) return;
          // belt-and-braces: a replacement must never escape the arm hide rules
          oldEl.classList.forEach((cls) => {
            if (cls.indexOf('combo-control-') === 0) freshEl.classList.add(cls);
          });
          oldEl.replaceWith(freshEl);
        });
      }

      this.updateReviewsSection(url);
      this.updateRebuySection(url)
    }

    async updateRebuySection(url) {
      // Refresh every Rebuy widget IN PLACE: fetch the section rendered for the
      // new product and copy the data-rebuy-* attributes onto the live elements.
      // Never replace the widget DOM — Rebuy's MutationObserver would remount it
      // asynchronously with stale cached data, racing (and often clobbering) the
      // reinit() refresh below.
      const sections = new Set(
        [...document.querySelectorAll('div[data-rebuy-id]')]
          .map((el) => el.closest('.shopify-section'))
          .filter(Boolean),
      );

      await Promise.all(
        [...sections].map(async (section) => {
          const sectionId = section.id.split('shopify-section-')[1];
          const doc = await this.fetchSectionDoc(this.sectionUrl(url, sectionId));
          if (!doc) return;
          section.querySelectorAll('div[data-rebuy-id]').forEach((el) => {
            const fresh = doc.querySelector(`div[data-rebuy-id="${el.dataset.rebuyId}"]`);
            if (!fresh) return;
            ['data-rebuy-shopify-product-ids', 'data-rebuy-shopify-variant-ids', 'data-rebuy-shopify-collection-ids'].forEach(
              (attr) => {
                if (fresh.hasAttribute(attr)) {
                  el.setAttribute(attr, fresh.getAttribute(attr));
                } else {
                  el.removeAttribute(attr);
                }
              },
            );
          });
        }),
      );

      // force-refresh every widget from the updated attributes
      window.Rebuy?.reinit();
    }

    replaceHTML(selector) {
      const oldEl = document.querySelector(selector);
      const newEl = this.doc.querySelector(selector);

      if (this.doc && oldEl && newEl) {
        oldEl.replaceWith(newEl);
      }
    }

    clearGroupLabel() {
      // Combo PDP: when a swatch in another style group is chosen, this group's
      // heading drops its color name, price preview, and badges.
      this.querySelectorAll('[data-js-pdp-color-label]').forEach((el) => el.remove());
      this.querySelectorAll('.ProductSwatches-label-price').forEach((el) => el.remove());
      this.querySelectorAll('.flash-sale-badge-and-price').forEach((el) => el.remove());
      this.querySelectorAll('.swatch-badge').forEach((el) => el.remove());
    }

    async updateReviewsSection(url) {
      // The main Judge.me widget lives in its own section and is fully
      // server-rendered per product — refetch that section for the new URL
      // so reviews stay truthful after a client-side product swap.
      const widget = document.getElementById('judgeme_product_reviews');
      const section = widget?.closest('.shopify-section');
      if (!section) return;
      // rapid successive swaps race: an older product's response can land
      // AFTER a newer one — only the latest request may apply (shared across
      // pickers via the constructor, so cross-group swaps count too)
      const requestSeq = (ProductSwatches.reviewsRequestSeq = (ProductSwatches.reviewsRequestSeq || 0) + 1);
      const sectionId = section.id.split('shopify-section-')[1];
      const doc = await this.fetchSectionDoc(this.sectionUrl(url, sectionId));
      if (requestSeq !== ProductSwatches.reviewsRequestSeq) return;
      const fresh = doc?.getElementById('judgeme_product_reviews');
      if (fresh) {
        // the live widget may itself have been replaced while we fetched
        const liveWidget = document.getElementById('judgeme_product_reviews');
        if (liveWidget) liveWidget.replaceWith(fresh);
        window.jdgm?.init?.();
      }
    }

    formatPrice(price) {
      const formatted = (price / 100).toFixed(2);
      return formatted.endsWith('.00') ? formatted.slice(0, -3) : formatted;
    }

    updateSwatchLabel(swatch) {
      const swatchContainer = swatch.closest('.ProductSwatches-category');
      const jsLabel = swatchContainer.querySelector('[data-js-pdp-color-label]');

      // Get global discount rate
      const globalDiscountRate = parseFloat(this.dataset.globalDiscountRate) || 0;

      // SALE / LIMITED chips — combo groups only (their styles live in
      // combo-pdp.css, which loads with the combo PDP; legacy PDPs keep
      // communicating sale state via the Sale: category). ONE badge at a time,
      // SALE outranks LIMITED. The badge rides the price element, right of the
      // price; when no price element renders it follows the color name.
      const isComboGroup = Boolean(this.dataset.comboGroup);
      const saleChip =
        isComboGroup && swatch.classList.contains('is-sale')
          ? '<span class="swatch-badge swatch-badge--sale">SALE</span>'
          : '';
      const limitedChip =
        isComboGroup && swatch.dataset.limited === 'true'
          ? '<span class="swatch-badge swatch-badge--limited">LIMITED</span>'
          : '';
      const priceChips = saleChip || limitedChip;

      if (jsLabel) {
        jsLabel.innerHTML = swatch.dataset.colorLabel;
        this.querySelector('.ProductSwatches-label-price')?.remove();
        this.querySelector('.flash-sale-badge-and-price')?.remove();
        // any chip still standing is a stray (e.g. the no-price fallback of a
        // previous selection) — without this sweep it survives every relabel
        // and duplicates the fresh chips
        this.querySelectorAll('.swatch-badge').forEach((el) => el.remove());

        let price = parseFloat(swatch.dataset.price);
        const compare = parseFloat(swatch.dataset.compare);
        const hasRegularSale = compare && price < compare;

        // Check if this is a sale swatch (has is-sale class)
        const isSaleSwatch = swatch.classList.contains('is-sale');

        if (swatch.dataset.discountValue) {
          const badgeHTML = swatch.dataset.badgeText
            ? `<span class="flash-sale-badge">${swatch.dataset.badgeText}</span>`
            : '';

          let discountPrice = price;

          if (swatch.dataset.discountType == 'Percentage') {
            discountPrice = (price * (1 - swatch.dataset.discountValue / 100)).toFixed(2);
          } else {
            discountPrice = price - swatch.dataset.discountValue * 100;
          }

          jsLabel.insertAdjacentHTML(
            'afterend',
            `
            <span class="flash-sale-badge-and-price">
              <span class="flash-sale-price">$${this.formatPrice(discountPrice)}</span>
              <s class="flash-sale-original-price">$${this.formatPrice(price)}</s>
              ${badgeHTML}${priceChips}
            </span>
            `,
          );
          return;
        }

        // Apply global discount only for sale swatches
        if (globalDiscountRate > 0 && isSaleSwatch && hasRegularSale) {
          const discountFactor = (100 - globalDiscountRate) / 100;
          const globalDiscountedPrice = price * discountFactor;

          jsLabel.insertAdjacentHTML(
            'afterend',
            `<div class="ProductSwatches-label-price" style="margin-left: 4px;">
              <div class="product-price">
                <span class="Product-info-current_price body-large js-price-preview current_price on-sale">
                  <span class="sale-price">$${this.formatPrice(globalDiscountedPrice)}</span>
                  <del class="compare-price">$${this.formatPrice(compare)}</del>
                </span>
              </div>
              ${priceChips}
            </div>`,
          );
        } else if (hasRegularSale) {
          jsLabel.insertAdjacentHTML(
            'afterend',
            `<div class="ProductSwatches-label-price" style="margin-left: 4px;">
              <div class="product-price">
                <span class="Product-info-current_price body-large js-price-preview current_price on-sale">
                  <span class="sale-price">$${this.formatPrice(price)}</span>
                  <del class="compare-price">$${this.formatPrice(compare)}</del>
                </span>
              </div>
              ${priceChips}
            </div>`,
          );
        } else if (priceChips) {
          // chips with no renderable price element — keep them visible after the name
          jsLabel.insertAdjacentHTML('beforeend', ' ' + priceChips);
        }
      } else {
        this.querySelector('[data-js-pdp-color-label]')?.remove();
        this.querySelector('.ProductSwatches-label-price')?.remove();
        this.querySelector('.flash-sale-badge-and-price')?.remove();
        // sweep strays before rendering (see the jsLabel branch)
        this.querySelectorAll('.swatch-badge').forEach((el) => el.remove());

        const label = swatchContainer.querySelector('.ProductSwatches-label');
        label.innerHTML += `<span data-js-pdp-color-label>${swatch.dataset.colorLabel}</span>`;

        let price = parseFloat(swatch.dataset.price);
        const compare = parseFloat(swatch.dataset.compare);
        const hasRegularSale = compare && price < compare;

        // Check if this is a sale swatch (has is-sale class)
        const isSaleSwatch = swatch.classList.contains('is-sale');


        if (swatch.dataset.discountValue) {
          const badgeHTML = swatch.dataset.badgeText
            ? `<span class="flash-sale-badge">${swatch.dataset.badgeText}</span>`
            : '';

          let discountPrice = price;

          if (swatch.dataset.discountType == 'Percentage') {
            discountPrice = (price * (1 - swatch.dataset.discountValue / 100)).toFixed(2);
          } else {
            discountPrice = price - swatch.dataset.discountValue * 100;
          }

          label.innerHTML += `
            <span class="flash-sale-badge-and-price">
              <span class="flash-sale-price">$${this.formatPrice(discountPrice)}</span>
              <s class="flash-sale-original-price">$${this.formatPrice(price)}</s>
              ${badgeHTML}${priceChips}
            </span>
          `;
          return;
        }

        // Apply global discount only for sale swatches
        if (globalDiscountRate > 0 && isSaleSwatch && hasRegularSale) {
          const discountFactor = (100 - globalDiscountRate) / 100;
          const globalDiscountedPrice = price * discountFactor;

          label.innerHTML += `
            <div class="ProductSwatches-label-price" style="margin-left: 4px;">
              <div class="product-price">
                <span class="Product-info-current_price body-large js-price-preview current_price on-sale">
                  <span class="sale-price">$${this.formatPrice(globalDiscountedPrice)}</span>
                  <del class="compare-price">$${this.formatPrice(compare)}</del>
                </span>
              </div>
              ${priceChips}
            </div>`;
        } else if (hasRegularSale) {
          label.innerHTML += `
            <div class="ProductSwatches-label-price" style="margin-left: 4px;">
              <div class="product-price">
                <span class="Product-info-current_price body-large js-price-preview current_price on-sale">
                  <span class="sale-price">$${this.formatPrice(price)}</span>
                  <del class="compare-price">$${this.formatPrice(compare)}</del>
                </span>
              </div>
              ${priceChips}
            </div>`;
        } else if (priceChips) {
          // chips with no renderable price element — keep them visible after the
          // name, INSIDE the name span so the next relabel's innerHTML rewrite
          // cleans them up (a label-level append would orphan them: the jsLabel
          // branch only removes the wrapper/flash containers)
          label.querySelector('[data-js-pdp-color-label]')?.insertAdjacentHTML('beforeend', ' ' + priceChips);
        }
      }
    }

    handleQuickshopSwatchClick(event) {
      const handle = event.target.closest('.swatch').dataset.handle;
      const quickshopDrawer = this.closest('quickshop-drawer');

      // Capture currently selected sizes before switching
      const checkedInputs = quickshopDrawer.querySelectorAll('.quickshop-product-option-input:checked');
      const selectedSizes = Array.from(checkedInputs).map((input) => input.dataset.size);

      quickshopDrawer.fetchContent(handle, selectedSizes);
    }

    handleBundleSwatchClick(event) {
      const swatch = event.target.closest('.swatch');
      const productUrl = swatch.dataset.url.split('?')[0];

      const dataHandle = swatch.dataset.handle;
      const embroideryPopup = document.querySelector('embroidery-popup');

      const container = event.target.closest('.js-smp-bundle-snippet');
      const collectionHandle = window.location.pathname.split('/').pop();

      if (embroideryPopup && dataHandle && container.dataset.hasEmbroidery == 'true') {
        embroideryPopup.dataset.productHandle = dataHandle;
      }

      const smpBundle = container.closest('smp-bundle');

      const sizeLabels = container.querySelectorAll('.quickshop-product-option-input:checked + label');
      const sizeString =
        sizeLabels && sizeLabels.length > 0
          ? Array.from(sizeLabels)
              .map((label) => label.innerText)
              .join(',')
          : '';

      fetch(productUrl + '?section_id=smp-bundle-product&path=%2Fcollections%2F' + collectionHandle)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const { processedHtml, uniqueId: processedUniqueId } = window.bundleIdManager.processFetchedHtml(
            html,
            swatch.dataset.handle || 'unknown',
          );

          doc.body.innerHTML = processedHtml;
          const newContainer = doc.querySelector('.js-smp-bundle-snippet-container');

          if (newContainer && container) {
            container.querySelectorAll('input:checked').forEach((input) => {
              const newInput = newContainer.querySelector(`input[data-size="${input.dataset.size}"]`);

              if (newInput) {
                newInput.setAttribute('checked', 'checked');
              }
            });
            container.innerHTML = newContainer.innerHTML;
            smpBundle.optionInputs = smpBundle.querySelectorAll('.quickshop-product-option-input');
            smpBundle.attachOptionChangeListeners();
          }
          smpBundle.recalculateSelectedItems();
          smpBundle.updateAddToCartState();
        });
    }

    updateAvailabilityStyle() {
      const collectionHandle = this.dataset.collectionHandle;

      if (!collectionHandle) {
        console.error('Collection handle is missing from dataset');
        return;
      }

      let fetchString = `/collections/${collectionHandle}?view=collection-json&filter.v.availability=1`;
      let variantSelects = document.querySelector('variant-selects');

      if (this.isBundle) {
        variantSelects = this.closest('.smpbundle-Product-sections').querySelector('.smpbundle-Product-controls');
      }

      if (this.isQuickshop) {
        variantSelects = this.closest('quickshop-drawer').querySelector('.quickshop-options-container');
      }

      if (!variantSelects) {
        console.error('variant-selects element not found');
        return;
      }

      if (variantSelects.dataset.sizing == 'regular') {
        const sizeInput = variantSelects.querySelector('input:checked');
        if (!sizeInput) {
          console.error('No checked size input found');
          return;
        }
        const size = this.isBundle || this.isQuickshop ? sizeInput.dataset.size : sizeInput.value;
        fetchString += `&filter.v.option.size=${size}`;
      } else if (variantSelects.dataset.sizing == 'gift') {
        const sizeInput = variantSelects.querySelector('input:checked');
        if (!sizeInput) {
          console.error('No checked size input found');
          return;
        }
        const size = sizeInput.value;
        fetchString += `&filter.v.option.value=${size}`;
      } else {
        const sizes = variantSelects.querySelectorAll('input:checked');
        if (sizes.length === 0) {
          console.error('No checked size inputs found');
          return;
        }
        sizes.forEach((size, index) => {
          if (index == 0) {
            fetchString += `&filter.v.option.band+size=${this.isBundle || this.isQuickshop ? size.dataset.size : size.value}`;
          } else if (index == 1) {
            fetchString += `&filter.v.option.cup+size=${this.isBundle || this.isQuickshop ? size.dataset.size : size.value}`;
          }
        });
      }

      fetch(fetchString)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          if (!data.availableColors) return;
          const colors = data.availableColors.map((color) => color.toLowerCase().replace(' ', '-'));
          this.swatches.forEach((swatch) => {
            const color = swatch.dataset.colorLabel;
            if (colors.includes(color)) {
              swatch.querySelector('.swatch-inner').classList.remove('swatch--oos');
            } else {
              swatch.querySelector('.swatch-inner').classList.add('swatch--oos');
            }
          });
        })
        .catch((error) => {
          console.error('Fetch error:', error);
        });
    }
  }

  customElements.define('product-swatches', ProductSwatches);
}
